import { DateTime } from "luxon";
import { createSchema, ZodOutputFor } from "../zod-utils";
import { z } from "zod/v3";
import { PlainMessage, Timestamp } from "@bufbuild/protobuf";
import { InstanceMetadata as ProtoInstanceMetadata } from "@opstel/gen/knop/ui/v1/api/instance_loading_pb";

export interface InstanceMetadata {
  instanceId: string;
  location: string;
  scenarioStart: DateTime;
  scenarioEnd: DateTime;
}

export const instanceMetadataSchema = createSchema<
  InstanceMetadata,
  PlainMessage<ProtoInstanceMetadata>
>({
  instanceId: z.string().min(1, { message: "InstanceMetadata instanceId should not be empty" }),
  location: z.string().min(1, { message: "InstanceMetadata location should not be empty" }),
  scenarioStart: z
    .instanceof(Timestamp, { message: "InstanceMetadata scenario start should not be empty" })
    .refine((timestamp) => timestamp)
    .transform((val) => DateTime.fromJSDate(val.toDate())),
  scenarioEnd: z
    .instanceof(Timestamp, { message: "InstanceMetadata scenario end should not be empty" })
    .refine((timestamp) => timestamp)
    .transform((val) => DateTime.fromJSDate(val.toDate())),
}) satisfies ZodOutputFor<InstanceMetadata>;
